import { DeleteOutlined } from "@ant-design/icons";
import { Divider, Flex, Form, Tag } from "antd";
import styled from "styled-components";
import { FormWrapper } from "../components/styles";

export const UploadInfoText = styled.p<{ color?: string; fontWeight?: string | number }>`
  color: ${(props) => props.color || "#000000"};
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  line-height: normal;
  margin-bottom: 20px;
  margin-top: 0;
`;

export const VariableTag = styled(Tag)`
  margin-right: 0;
  margin-bottom: 4px;
`;

export const DeleteOutlinedIcon = styled(DeleteOutlined)`
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
`;

export const CustomRender = styled(Flex)`
  background-color: transparent;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);

    ${DeleteOutlinedIcon} {
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }
  }
`;

export const FileLabel = styled.div`
  color: #0d63ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
`;

export const UploadedFilesLabel = styled.div`
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 16px;
`;

export const FormWrapperContainer = styled(FormWrapper)`
  margin-top: 0px;
`;

export const FormItem = styled(Form.Item)`
  .ant-form-item-label{
    padding-bottom: 0 !important;
  }
  .shipping_upload_wrapper{
    padding-bottom: 0;
  }
`;

export const FormItemLabel = styled.label`
  font-size: 16px;
  font-weight: 500;
`;


export const FormDivider = styled(Divider)`
  border: 0.5px solid #C2C2C2;
  margin: 0;
  margin-bottom: 16px;
  padding: 0;
`;

export const TrackingNumberContainer = styled.div`
  padding-bottom: 14px;
`